import { create } from "zustand";
import { SetUserFn, UserOptional, UserUpdater } from "./types";
import { setCookie } from "../../utils";
import { AccessList } from "../../pages/admin-panel/users/types";

interface State {
  user: UserOptional;
  sentAuthReq: boolean;
}

interface Action {
  setUser: SetUserFn;
  setAuthReq: (v: boolean) => void;
  userLogout: () => void;
  hasUserAccess: (access_list: AccessList) => boolean;
}

const useUserStore = create<State & Action>((set, get) => ({
  user: null,
  sentAuthReq: false,
  setUser: (updater: UserUpdater): void => {
    if (typeof updater === "function") {
      set((state) => ({ user: updater(state.user) }));
    } else {
      set({ user: updater });
    }
  },
  setAuthReq: (sentAuthReq: boolean): void => {
    set({ sentAuthReq });
  },
  userLogout: (): void => {
    setCookie("token", "");
    set({ user: null });
  },
  hasUserAccess: (access_list: AccessList): boolean => {
    const user: UserOptional = get().user;

    if (!user) return false;

    if (user.access_list.includes("Admin")) return true;

    for (let i = 0; i < access_list.length; i++)
      if (user.access_list.includes(access_list[i])) return true;

    return false;
  },
}));

export default useUserStore;
